import React, { useState, useEffect } from 'react';
import './App.css';

// Use environment variable or fallback to Lambda URL placeholder
const API_URL = process.env.REACT_APP_API_URL || 'REPLACE_WITH_LAMBDA_URL';

function App() {
  const [attendees, setAttendees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAttendees();
  }, []);

  const fetchAttendees = async () => {
    try {
      // Check if API_URL is configured
      if (API_URL === 'REPLACE_WITH_LAMBDA_URL') {
        console.warn('API URL not configured. Please set REACT_APP_API_URL environment variable.');
        // Use mock data for development
        setAttendees([
          {
            name: 'John Smith',
            email: 'john.smith@example.com',
            title: 'CEO',
            company: 'Tech Innovations Inc.',
            profileImage: 'https://ui-avatars.com/api/?name=John+Smith&size=200&background=667eea&color=fff'
          },
          {
            name: 'Sarah Johnson',
            email: 'sarah.johnson@example.com',
            title: 'CTO',
            company: 'Digital Solutions Ltd.',
            profileImage: 'https://ui-avatars.com/api/?name=Sarah+Johnson&size=200&background=667eea&color=fff'
          },
          {
            name: 'Michael Chen',
            email: 'michael.chen@example.com',
            title: 'VP of Engineering',
            company: 'Cloud Systems Corp.',
            profileImage: 'https://ui-avatars.com/api/?name=Michael+Chen&size=200&background=667eea&color=fff'
          }
        ]);
        setLoading(false);
        return;
      }

      const response = await fetch(`${API_URL}api/attendees`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors'
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      setAttendees(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching attendees:', err);
      // Set some default data even on error
      setAttendees([
        {
          name: 'John Smith',
          email: 'john.smith@example.com',
          title: 'CEO',
          company: 'Tech Innovations Inc.',
          profileImage: 'https://ui-avatars.com/api/?name=John+Smith&size=200&background=667eea&color=fff'
        },
        {
          name: 'Sarah Johnson',
          email: 'sarah.johnson@example.com',
          title: 'CTO',
          company: 'Digital Solutions Ltd.',
          profileImage: 'https://ui-avatars.com/api/?name=Sarah+Johnson&size=200&background=667eea&color=fff'
        },
        {
          name: 'Michael Chen',
          email: 'michael.chen@example.com',
          title: 'VP of Engineering',
          company: 'Cloud Systems Corp.',
          profileImage: 'https://ui-avatars.com/api/?name=Michael+Chen&size=200&background=667eea&color=fff'
        }
      ]);
      setError('Using demo data. Backend connection unavailable.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      {/* Hero Section with Dinner Invitation */}
      <section className="hero-section">
        <div className="hero-overlay">
          <div className="container">
            <h1 className="hero-title">Annual Executive Dinner</h1>
            <p className="hero-subtitle">An Evening of Great Conversations, Food and Wine </p>
            <div className="event-details">
              <div className="detail-item">
                <span className="icon">📅</span>
                <span>Thursday, November 13, 2024</span>
              </div>
              <div className="detail-item">
                <span className="icon">🕰️</span>
                <span>6:30 PM - Whenever </span>
              </div>
              <div className="detail-item">
                <span className="icon">📍</span>
                <span>The Tasting House, 368 Village Lane, Los Gatos</span>
              </div>
            </div>
            <p className="hero-subtitle"></p>
            <div className="event-details">
              <div className="detail-item">
                <span className="icon"></span>
                <span>Agenda: 6:30 Mingle, 7:30 ish Dinner , Desserts, Drinks </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Menu Section */}
      <section className="menu-section">
        <div className="container">
          <h2 className="section-title">Evening Menu</h2>
          <div className="menu-grid">
            <div className="menu-card">
              <h3>Appetizers</h3>
              <ul>
                <li>Salmon Carpaccio - trout | dill | chive | créme fraîche | capers</li>
                <li>Pear & Plum - goat cheese| frisée | almonds</li>
                <li>Beef Tartare - tenderloin | traditional accoutrements | bread </li>
              </ul>
            </div>
            <div className="menu-card">
              <h3>Main Course</h3>
              <ul>
                <li>Pumpkin Gnocchi - pumpkin purée | parmesan | pepita seeds</li>
                <li>Mt. Lassen Trout - seasonal vegetables |nước chấm beurre blanc </li>
                <li>Steak Frites - prime strip steak | au poivre </li>
              </ul>
            </div>
            <div className="menu-card">
              <h3>Desserts</h3>
              <ul>
                <li>Basque Cheesecake </li>
                <li>Chocolate Something Awesome</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Wine Selection */}
      <section className="wine-section">
        <div className="container">
          <h2 className="section-title">Wine Selection</h2>
          <div className="wine-grid">
            <div className="wine-card">
              <h3>White Wines</h3>
              <ul>
                <li> MV Piper-Heidsieck, "Essentiel," Blanc de Noirs </li>
                <li> 2024 Hippolyte Reverdy, Sancerre </li>
                <li> 2018 Martinelli Winery, Chardonnay</li>
              </ul>
            </div>
            <div className="wine-card">
              <h3>Red Wines</h3>
              <ul>
                <li> 2018 Vincent Christopher, Pinot Noir </li>
                <li> 2019 Rafael et Fils, Cabernet Sauvignon </li>
              </ul>
            </div>
            <div className="wine-card">
              <h3>Chateneuf du Pape</h3>
              <ul>
                <li> 2018 Domaine du Vieux Telegraphe 1.5 L </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Attendees Section */}
      <section className="attendees-section">
        <div className="container">
          <h2 className="section-title">Friends Attending</h2>
          
          {loading && (
            <div className="loading">
              <div className="spinner"></div>
              <p>Loading attendees...</p>
            </div>
          )}
          
          {error && (
            <div className="info-message">
              <p>{error}</p>
            </div>
          )}
          
          {!loading && (
            <div className="attendees-grid">
              {attendees.map((attendee, index) => (
                <div key={attendee.id || index} className="attendee-card">
                  <div className="attendee-image-wrapper">
                    <img 
                      src={attendee.profileImage || `https://ui-avatars.com/api/?name=${encodeURIComponent(attendee.name)}&size=200&background=667eea&color=fff`} 
                      alt={attendee.name}
                      className="attendee-image"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(attendee.name)}&size=200&background=667eea&color=fff`;
                      }}
                    />
                  </div>
                  <div className="attendee-info">
                    <h3 className="attendee-name">{attendee.name}</h3>
                    {attendee.title && (
                      <p className="attendee-title">{attendee.title}</p>
                    )}
                    {attendee.company && (
                      <p className="attendee-company">{attendee.company}</p>
                    )}
                    {attendee.linkedinUrl && (
                      <a 
                        href={attendee.linkedinUrl} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="linkedin-link"
                        aria-label={`View ${attendee.name}'s LinkedIn profile`}
                      >
                        <svg className="linkedin-icon" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                        </svg>
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 RREmerge Annual Executive Dinner. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
